import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Matriz } from '../../../shared/model/matriz';
import Spinner from '../../../shared/spinner';
import { ButtonAlterar, ButtonAtivar, ButtonInativar } from '../../../shared/buttons';
import MatrizService from '../../../services/matrizService';
import ConfirmModal from '../../../shared/customAlertConfirm';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import { useSlug } from '../../hooks/UseSlug';
import ResponsivePagination from 'react-responsive-pagination';
import { faFilter, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ProtectedAction } from '../../../AccessControl';

function MatrizComponent() {
  useVerificaPermissao();
  const navigate = useNavigate();
  const slug = useSlug();

  const [loading, setLoading] = useState(true);
  const [matriz, setMatriz] = useState<Matriz[]>([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState<{ id: any; ativo: boolean } | null>(null);

  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);

  const [filtros, setFiltros] = useState(false);
  const [codigoFiltro, setCodigoFiltro] = useState('');
  const [nomeFiltro, setNomeFiltro] = useState('');
  const [cidadeFiltro, setCidadeFiltro] = useState('');

  const matrizService: MatrizService = new MatrizService();

  const listarTodasMatrizes = async (page = 1) => {
    try {
      setLoading(true);

      const filtros = {
        codigo: codigoFiltro || undefined,
        nome: nomeFiltro || undefined,
        cidade: cidadeFiltro || undefined,
      };

      const responseList = await matrizService.listarTodasMatrizes(page - 1, 10, filtros);
      const jsonPage = responseList.data;

      setMatriz(jsonPage.content);
      setTotalPaginas(jsonPage.totalPages);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };


  const ativarInativarMatriz = (id: any, ativo: boolean) => {
    setCurrentAction({ id, ativo });
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    if (currentAction) {
      const { id } = currentAction;

      try {
        await matrizService.ativarInativarMatriz(id);
        listarTodasMatrizes(paginaAtual);
      } catch (err) {
        console.error(err);
      } finally {
        setConfirmOpen(false);
        setCurrentAction(null);
      }
    }
  };

  useEffect(() => {
    listarTodasMatrizes(paginaAtual);
  }, [paginaAtual]);

  return (
    <>
      <div className="position-relative m-md-3">
        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
          <h5>Origens &gt; Matriz</h5>
          <div style={{ display: 'flex', gap: '10px' }}>
            <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
              Filtros
            </Button>

            <ProtectedAction>
              <Button
                onClick={() => navigate(`${slug ? `/${slug}` : ''}/origens-matriz/inclusao`, { state: { id: null } })}
                id="App-button-cor-principal-escura"
              >
                + Nova Matriz
              </Button>
            </ProtectedAction>

          </div>
        </div>

        {filtros && (
          <>
            <Row className="mb-4" style={{ marginTop: '15px' }}>
              <Form.Group as={Col} md='2'>
                <Form.Label>Código </Form.Label>
                <input type="text" className="form-control" value={codigoFiltro} onChange={(e) => setCodigoFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4'>
                <Form.Label>Nome</Form.Label>
                <input type="text" className="form-control" value={nomeFiltro} onChange={(e) => setNomeFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4'>
                <Form.Label>Cidade</Form.Label>
                <input type="text" className="form-control" value={cidadeFiltro} onChange={(e) => setCidadeFiltro(e.target.value)} />
              </Form.Group>
            </Row>
            <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
              <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
                <FontAwesomeIcon icon={faFilter} />
              </Button>
              <Button id="App-button-cor-principal-escura" onClick={() => listarTodasMatrizes(paginaAtual)}>
                <FontAwesomeIcon icon={faRefresh} />
              </Button>
            </div>
          </>
        )}

        {loading ? (
          <Spinner loading={loading} />
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col" id="App-header-table">Código</th>
                  <th scope="col" id="App-header-table">Razão Social</th>
                  <th scope="col" id="App-header-table">CNPJ</th>
                  <th scope="col" id="App-header-table">Cidade</th>
                  <th scope="col" id="App-header-table">Telefone</th>
                  <th scope="col" id="App-header-table">Email</th>
                  <ProtectedAction>
                    <th scope="col" id="App-header-table">Alteração</th>
                    <th scope="col" id="App-header-table">Status</th>
                  </ProtectedAction>
                </tr>
              </thead>
              <tbody>
                {matriz.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nome}</td>
                    <td>{item.cnpj}</td>
                    <td>{item.cidade}</td>
                    <td>{item.foneComercial}</td>
                    <td>{item.email}</td>

                    <ProtectedAction>
                      <td>
                        <Link to={`${slug ? `/${slug}` : ''}/origens-matriz/alteracao`} state={{ id: item.id }}>
                          <ButtonAlterar />
                        </Link>
                      </td>
                      <td>
                        {item.ativo ? (
                          <ButtonInativar onClick={() => ativarInativarMatriz(item.id, item.ativo)} />
                        ) : (
                          <ButtonAtivar onClick={() => ativarInativarMatriz(item.id, item.ativo)} />
                        )}
                      </td>
                    </ProtectedAction>
                  </tr>
                ))}
              </tbody>
            </table>

            <ResponsivePagination
              current={paginaAtual}
              total={totalPaginas}
              onPageChange={(page) => setPaginaAtual(page)}
            />

            {confirmOpen && (
              <ConfirmModal
                message={currentAction?.ativo
                  ? 'Tem certeza que deseja inativar este item?'
                  : 'Tem certeza que deseja ativar este item?'}
                onConfirm={handleConfirm}
                onCancel={() => {
                  setConfirmOpen(false);
                  setCurrentAction(null);
                }}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default MatrizComponent;